export type FileVisualType = 'audio' | 'diarization' | 'test' | 'zoom';

export function getFileVisualType(name: string): FileVisualType {
  const lower = (name || '').toLowerCase();
  if (lower.includes('zoom')) return 'zoom';
  if (lower.includes('diarization') || lower.includes('diariz')) return 'diarization';
  if (lower.includes('test') || lower.includes('тест')) return 'test';
  return 'audio';
}

export function getFileSourceTag(name: string): string {
  return (name || '').toLowerCase().includes('zoom') ? 'Zoom' : 'STT';
}
